import React, {useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import IranFlag from "../../assets/images/iran.webp";
import '../../css/cover.css';
import '../../css/styles.css';
import api from "../../api";
import persianJs from 'persianjs';
import LoadingSpinner from "../Loading";
import Cookies from "js-cookie";
import {toast, ToastContainer} from "react-toastify";
import {e2p, p2e} from "../../utils/utils";
import {useSearchParams} from "react-router-dom";
import {getMyInfo} from "../../auth";


function AddCar() {
    const [data, setData] = useState({
        name: '',
        lastname: '',
        address: '',
        mobile_number: '',
        isMale: true,
        phone_number: '',
        description: '',
        car: {
            model_name: '',
            plate: {
                first: '',
                second: '',
                letter: '',
                third: ''
            },
            chassis_number: '',
            color: '',
            description: ''
        }
    });
    const [plates, setPlates] = useState([]);
    const [carId, setCarId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const [info, setInfo] = useState(null);
    
    const enteredPlate = searchParams.get('plateNo');
    
    const handleReception = async (e) => {
        setIsLoading(true);
        e.preventDefault();
        if (Cookies.get('role') === 'ادمین') {
            toast.error('ادمین نمیتواند پذیرش انجام دهد')
            setIsLoading(false);
            return;
        }
        
        if (info.company?.wallet?.balance < 50000) {
            toast.error('موجودی کافی نیست. حداقل موجودی باید ۵۰۰۰۰ ریال باشد')
            setIsLoading(false);
            return;
        }
        
        const plate = `${data.car.plate.third}${data.car.plate.letter}${data.car.plate.second} ${data.car.plate.first}`
        const persianPlate = persianJs(plate).englishNumber().toString();
        
        if (plates.indexOf(persianPlate) !== -1 && persianPlate.length === 9) {
            toast.error('این شماره پلاک قبلا ثبت شده است')
            setIsLoading(false);
            return
        }
        
        try {
            
            const carOwnerData = {
                name: data.name,
                lastname: data.lastname,
                address: data.address,
                mobile_number: p2e(data.mobile_number),
                is_male: data.isMale,
                phone_number: p2e(data.phone_number),
                description: data.description,
                car: {
                    model_name: data.car.model_name,
                    plate: e2p(plate),
                    chassis_number: p2e(data.car.chassis_number),
                    color: data.car.color,
                    description: data.car.description
                }
            }
            api.post('/car-owner', carOwnerData)
                .then((res) => {
                    let carId = res.data.data.car.id;
                    setCarId(carId);
                    try {
                        const requestBody = {
                            status: 0,
                            kilometerage: 0,
                            owner_permission: 1,
                            amount_of_fuel: '',
                            description: '',
                            car_id: carId,
                        };
                        api.post('/repair-request', requestBody)
                            .then((resReq) => {
                                const requestId = resReq.data.data.id;
                                window.location.href = `/car/${carId}/reception/${requestId}`;
                            })
                    } catch (err) {
                        toast.error(err.response.data.message)
                    }
                    
                })
                .catch((err) => {
                    toast.error(err.response.data.message)
                })
        } catch (err) {
            toast.error(err.response.data.message)
        } finally {
            setIsLoading(false);
        }
    }
    
    useEffect(() => {
        if (enteredPlate && enteredPlate.length === 9) {
            setData({
                ...data,
                car: {
                    ...data.car,
                    plate: {
                        first: enteredPlate.slice(0, 2),
                        letter: enteredPlate.slice(8, 9),
                        second: enteredPlate.slice(5, 8),
                        third: enteredPlate.slice(2, 4)
                    }
                }
            })
        }
        
        api.get(`/car/plates`)
            .then(res => {
                setPlates(res.data.data);
            })
            .catch(err => {
                setPlates([]);
            });
        
        async function fetchData() {
            const response = await getMyInfo();
            setInfo(response.data.data);
        }
        
        fetchData();
    }, []);
    
    return (
        <div>
            {isLoading ? <LoadingSpinner/> :
                <div className="content-wrapper">
                    <div className="container-xxl flex-grow-1 container-p-y">
                        
                        <div className="row justify-content-center">
                            <div className="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-6 col-xxl-6">
                                <h4 className="text-center">افزودن خودرو</h4>
                                <form className="align-items-center">
                                    <div className="card border-3 rounded-4 border-dark mb-4">
                                        <h5 className="card-header bg-dark text-center text-white fw-bold">مشخصات
                                            خودرو</h5>
                                        <div className="card-body">
                                            <div className="row pelak w-auto g-0 mb-3">
                                                <div className="col text-center">
                                                    <div className="row g-0">
                                                        <div className="col border-end-0 border-start">
                                                            <p className="text-center m-0 fw-bold iranNo">ایران</p>
                                                            <div>
                                                                <input
                                                                    className="border-0 text-center"
                                                                    type="text"
                                                                    onInput={(e) => e.target.value = e.target.value.slice(0, 2)}
                                                                    value={data.car.plate.first}
                                                                    onChange={(e) => setData({
                                                                        ...data,
                                                                        car: {
                                                                            ...data.car,
                                                                            plate: {
                                                                                ...data.car.plate,
                                                                                first: e.target.value,
                                                                            },
                                                                        },
                                                                    })}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col">
                                                            <input
                                                                className="border-0 text-center"
                                                                type="text"
                                                                onInput={(e) => e.target.value = e.target.value.slice(0, 3)}
                                                                value={data.car.plate.second}
                                                                onChange={(e) => setData({
                                                                    ...data,
                                                                    car: {
                                                                        ...data.car,
                                                                        plate: {
                                                                            ...data.car.plate,
                                                                            second: e.target.value,
                                                                        },
                                                                    },
                                                                })}
                                                            />
                                                        </div>
                                                        <div className="col">
                                                            <input
                                                                className="text-center border-2 border-gray h-100 border-top-0 border-bottom-0"
                                                                type="text"
                                                                maxLength="1"
                                                                value={data.car.plate.letter}
                                                                onChange={(e) => setData({
                                                                    ...data,
                                                                    car: {
                                                                        ...data.car,
                                                                        plate: {
                                                                            ...data.car.plate,
                                                                            letter: e.target.value,
                                                                        },
                                                                    },
                                                                })}
                                                            />
                                                        </div>
                                                        <div className="col">
                                                            <input
                                                                className="border-0 text-center"
                                                                type="text"
                                                                id="inputPelak"
                                                                onInput={(e) => e.target.value = e.target.value.slice(0, 2)}
                                                                value={data.car.plate.third}
                                                                onChange={(e) => setData({
                                                                    ...data,
                                                                    car: {
                                                                        ...data.car,
                                                                        plate: {
                                                                            ...data.car.plate,
                                                                            third: e.target.value,
                                                                        },
                                                                    },
                                                                })}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-auto leftSide">
                                                    <div className="flag">
                                                        <img src={IranFlag} alt="iran's flag"/>
                                                    </div>
                                                    <div className="iranText text-center">
                                                        <p>I.R.</p>
                                                        <p>IRAN</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mb-3">
                                                <label className='form-label'>نام خودرو <sup
                                                    className='text-danger'>*</sup></label>
                                                <input type="text" className="form-control shadow" name="CarType"
                                                       maxLength="50" value={data.car.model_name}
                                                       onChange={e => setData(
                                                           {
                                                               ...data,
                                                               car: {
                                                                   ...data.car,
                                                                   model_name: e.target.value
                                                               }
                                                           }
                                                       )}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className='form-label'>رنگ خودرو <sup
                                                    className='text-danger'>*</sup></label>
                                                <input type="text" className="form-control shadow" name="CarColor"
                                                       maxLength="50" value={data.car.color}
                                                       onChange={e => setData(
                                                           {
                                                               ...data,
                                                               car: {
                                                                   ...data.car,
                                                                   color: e.target.value
                                                               }
                                                           }
                                                       )}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className='form-label'>توضیحات خودرو</label>
                                                <textarea className="form-control shadow" name="car-description"
                                                          value={data.car.description}
                                                          onChange={e => setData(
                                                              {
                                                                  ...data,
                                                                  car: {
                                                                      ...data.car,
                                                                      description: e.target.value
                                                                  }
                                                              }
                                                          )}
                                                >
                                                </textarea>
                                            </div>
                                            <div className="mb-3">
                                                <label className='form-label'>شماره شاسی</label>
                                                <input type="text" className="form-control shadow" name="chassis-number"
                                                       value={data.car.chassis_number}
                                                       onChange={e => setData(
                                                           {
                                                               ...data,
                                                               car: {
                                                                   ...data.car,
                                                                   chassis_number: e.target.value
                                                               }
                                                           }
                                                       )}
                                                />
                                            </div>
                                        </div>
                                        <h5 className="card-header bg-dark text-white text-center fw-bold w-100">مشخصات
                                            کاربر</h5>
                                        <div className="card-body">
                                            <div className="gender mb-3">
                                                <label className='form-label'>جنسیت</label>
                                                <div className="form-check form-check-inline mt-3">
                                                    <label className="form-check-label" htmlFor="male">آقا</label>
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="gender"
                                                        id="male"
                                                        value={true}
                                                        checked={data.isMale}
                                                        onChange={e => setData(
                                                            {
                                                                ...data,
                                                                isMale: true
                                                            }
                                                        )}
                                                    />
                                                </div>
                                                <div className="form-check form-check-inline">
                                                    <label className="form-check-label" htmlFor="female">خانم</label>
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="gender"
                                                        id="female"
                                                        value={false}
                                                        checked={!data.isMale}
                                                        onChange={e => setData(
                                                            {
                                                                ...data,
                                                                isMale: false
                                                            }
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                            <div className="mb-3">
                                                <label className='form-label'>نام</label>
                                                <input type="text" className="form-control shadow" name="name"
                                                       maxLength="50" value={data.name}
                                                       onChange={e => setData(
                                                           {
                                                               ...data,
                                                               name: e.target.value
                                                           }
                                                       )}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className='form-label'>نام خانوادگی <sup
                                                    className='text-danger'>*</sup></label>
                                                <input type="text" className="form-control shadow" name="name"
                                                       maxLength="50" value={data.lastname}
                                                       onChange={e => setData(
                                                           {
                                                               ...data,
                                                               lastname: e.target.value
                                                           }
                                                       )}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className='form-label'>تلفن همراه <sup
                                                    className='text-danger'>*</sup></label>
                                                <input type="tel" className="form-control shadow" name="mobile-number"
                                                       maxLength="11" value={data.mobile_number}
                                                       onChange={e => setData(
                                                           {
                                                               ...data,
                                                               mobile_number: e.target.value
                                                           }
                                                       )}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className='form-label'>تلفن ثابت</label>
                                                <input type="tel" className="form-control shadow" name="phone-number"
                                                       maxLength="11" value={data.phone_number}
                                                       onChange={e => setData(
                                                           {
                                                               ...data,
                                                               phone_number: e.target.value
                                                           }
                                                       )}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className='form-label'>آدرس</label>
                                                <textarea className="form-control shadow" name="address"
                                                          value={data.address}
                                                          onChange={e => setData(
                                                              {
                                                                  ...data,
                                                                  address: e.target.value
                                                              }
                                                          )}
                                                >
                                                </textarea>
                                            </div>
                                            <div className="mb-3">
                                                <label className='form-label'>توضیحات</label>
                                                <textarea className="form-control shadow" name="explanations"
                                                          value={data.description}
                                                          onChange={e => setData(
                                                              {
                                                                  ...data,
                                                                  description: e.target.value
                                                              }
                                                          )}
                                                >
                                                </textarea>
                                            </div>
                                            <div className='d-grid gap-2'>
                                                <input type="submit" className="btn btn-warning"
                                                       onClick={handleReception} name="submit" value="ثبت و پذیرش"/>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            }
        
        </div>
    )
        ;
}

export default AddCar;
